export const RESET_LIST_BENE = "RESET_LIST_BENE";
export const SET_BENE_STORE = "SET_BENE_STORE";

export const FETCH_LIST_BENE_REQUEST = "FETCH_LIST_BENE_REQUEST";
export const FETCH_LIST_BENE_SUCCESS = "FETCH_LIST_BENE_SUCCESS";
export const FETCH_LIST_BENE_FAILURE = "FETCH_LIST_BENE_FAILURE";

export const FETCH_ADD_BENE_PROFILE_REQUEST = "FETCH_ADD_BENE_PROFILE_REQUEST";
export const FETCH_ADD_BENE_PROFILE_SUCCESS = "FETCH_ADD_BENE_PROFILE_SUCCESS";
export const FETCH_ADD_BENE_PROFILE_FAILURE = "FETCH_ADD_BENE_PROFILE_FAILURE";

export const FETCH_ADD_BENE_TEMPLATE_REQUEST = "FETCH_ADD_BENE_TEMPLATE_REQUEST";
export const FETCH_ADD_BENE_TEMPLATE_SUCCESS = "FETCH_ADD_BENE_TEMPLATE_SUCCESS";
export const FETCH_ADD_BENE_TEMPLATE_FAILURE = "FETCH_ADD_BENE_TEMPLATE_FAILURE";
